module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "record-cut-wrapper"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Video cutting")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "flat": "",
      "fab": ""
    },
    on: {
      "click": _vm.closeCutWindow
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('RecordCutSlider', {
    attrs: {
      "record": _vm.record,
      "processing": _vm.processing
    },
    on: {
      "range-update": _vm.updateRange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "op-messages text-center"
  }, [(_vm.processing) ? _c('div', [_c('div', {
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), _c('div', [_vm._v("Video is being processed. Please wait for the operation to complete.")])]) : _vm._e()]), _vm._v(" "), (!_vm.processing) ? _c('div', {
    staticClass: "text-right mt-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.cut_btn_disabled
    },
    on: {
      "click": _vm.cutRecord
    }
  }, [_vm._v("Cut Record")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88eeaabc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/RecordCut.vue
// module id = 1062
// module chunks = 1